<form [formGroup]="formGroup" class="tw-flex tw-flex-col tw-gap-4">
  <div class="tw-flex sm:tw-flex-col tw-justify-between tw-items-center tw-gap-8 sm:tw-gap-4">
    <app-input
      [testId]="'budget-form-name'"
      [label]="'budgetName' | i18n"
      [isRequired]="true"
      [manualTouched]="formGroup.get('name').touched"
      formControlName="name"
      class="tw-flex-1 sm:tw-w-full"
    ></app-input>
    <div class="tw-flex-1 sm:tw-w-full tw-flex tw-items-center tw-justify-start">
      <div class="tw-flex-1">
        <app-dropdown-select
          data-testid="budget-form-period"
          [options]="intervalTypesLabels"
          [selectedOption]="selectedPeriodLabel()"
          [label]="'budgetPeriod' | i18n"
          [isEnabled]="true"
          [customShadowClass]="'tw-shadow-dropdown'"
          [showGradientBorder]="false"
          (optionSelected)="setPeriod($event)"
        >
        </app-dropdown-select>
      </div>
    </div>
  </div>

  <div class="tw-flex tw-justify-between tw-items-center tw-gap-8">
    <app-input
      [testId]="'budget-form-amount'"
      [label]="'budgetAmount' | i18n"
      type="number"
      [isRequired]="true"
      [min]="minAmount"
      [manualTouched]="formGroup.get('amount').touched"
      formControlName="amount"
      class="tw-w-full"
    ></app-input>

    <app-currencies
      data-testid="budget-form-currency"
      class="tw-w-full tw-font-neutral-800"
      (onSelectCurrency)="onInput($event, 'currency')"
      [label]="'Currency'"
      [defaultCurrency]="formGroup.controls['currency']?.value || defaultSystemCurrency"
      [isRequired]="true"
      [detachPanel]="true"
    ></app-currencies>
  </div>

  <div class="tw-flex tw-flex-col tw-gap-1">
    <div class="tw-flex tw-items-center tw-gap-2 sm:tw-flex-wrap">
      <div
        class="tw-flex tw-gap-1 tw-font-bold tw-text-dt-text-tertiary tw-text-[12px] tw-shrink-0"
      >
        <span class="tw-whitespace-nowrap">{{ "category" | i18n }}</span>
        @if (selectedCategories().length === 0) {
          <span class="tw-text-sm">*</span>
        }
      </div>
      <div
        class="tw-flex tw-flex-1 sm:tw-flex-none sm:tw-order-last sm:tw-w-full tw-flex-wrap tw-gap-1"
      >
        @for (category of selectedCategories(); track $index) {
          <button
            aria-label="Delete Category"
            tabindex="-1"
            class="tw-rounded-3xl tw-bg-dt-custom-teal-11 tw-px-3 tw-py-1.5 tw-flex tw-items-center tw-gap-1 tw-max-w-full tw-min-w-0"
            (click)="removeSelectedCategory(category)"
          >
            <span class="tw-text-white tw-truncate">{{ category?.name }}</span>
            <icon [size]="4" [name]="'close'" [currentColor]="'white'" class="tw-shrink-0"></icon>
          </button>
        }
      </div>
      <span
        class="tw-font-medium tw-text-[14px] tw-text-dt-custom-teal-11 tw-cursor-pointer tw-shrink-0 sm:tw-ml-auto"
        (click)="addManualCategory()"
        >{{ "addNewCategory" | i18n }}</span
      >
    </div>
    <app-dropdown-search
      data-testid="budget-form-category"
      class="tw-w-full"
      [options]="categoryNames()"
      [placeholder]="'addCategory' | i18n"
      (optionSelected)="setCategory($event)"
      [isRequired]="selectedCategories().length === 0"
      [isPicker]="true"
      [manualTouched]="formGroup.get('category').touched"
      [allowCreate]="true"
      (createRequested)="addManualCategory()"
    ></app-dropdown-search>
  </div>

  <div class="tw-flex tw-justify-end tw-gap-4 tw-mt-2">
    <app-gloss-button
      [options]="{
        testId: 'budget-form-save',
        text: 'save' | i18n,
        fullClass: 'btn-primary-teal',
        type: 'submit',
        isEnabled: true,
        onClick: submit.bind(this),
      }"
      [isLoading]="submitting"
      class="sm:tw-w-full tw-w-1/2"
      fontClass="!tw-font-bold tw-text-[16px] tw-text-dt-slate-0"
    ></app-gloss-button>
  </div>
</form>
